module.exports = __webpack_public_path__ + "static/by-nc-sa-03dda63e80b9508d421e792236239ef1.svg";